import React from 'react';
import { motion } from 'framer-motion';
import { FiAlertCircle, FiArrowLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] w-full px-6 text-center">
      <div className="max-w-2xl w-full mx-auto">
        <motion.div 
          initial={{ opacity: 0, scale: 0.8 }} 
          animate={{ opacity: 1, scale: 1 }} 
          className="w-20 h-20 bg-brand-blue/10 rounded-full flex items-center justify-center mb-8 mx-auto border border-brand-blue/20"
        >
          <SafeIcon icon={FiAlertCircle} className="text-4xl text-brand-blue" />
        </motion.div>

        <motion.h1 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ delay: 0.1 }}
          className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight"
        >
          404 - Seite <br />
          <span className="text-brand-blue text-glow">nicht gefunden</span>
        </motion.h1>

        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ delay: 0.2 }}
          className="space-y-8"
        >
          <p className="text-xl text-gray-400 leading-relaxed max-w-lg mx-auto">
            Die von dir gesuchte Seite existiert nicht oder wurde verschoben.
          </p>
          
          <div className="pt-4">
            <Link 
              to="/geschaeftsfuehrer-video" 
              className="inline-flex items-center gap-3 bg-brand-blue text-white font-semibold py-4 px-10 rounded-lg shadow-[0_0_30px_rgba(47,107,255,0.3)] hover:shadow-[0_0_40px_rgba(47,107,255,0.5)] transition-all duration-300 hover:scale-105"
            >
              <SafeIcon icon={FiArrowLeft} />
              Zurück zur Hauptseite
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;